import React, { useState } from "react";
import { Alert, Row, Col, Form, Button } from "reactstrap";
import { Link, Navigate } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";

import { useProfile } from "../../hooks";
import { useAuth } from "../../context/AuthContext";

import NonAuthLayoutWrapper from "../../components/NonAutnLayoutWrapper";
import AuthHeader from "../../components/AuthHeader";
import FormInput from "../../components/FormInput";
import Loader from "../../components/Loader";

const Register = () => {
  // const { loading, error, success, register: registerUser } = useAuth();
  const { userProfile } = useProfile();

  const resolver = yupResolver(
    yup.object().shape({
      email: yup.string().email().required(),
      username: yup.string().required(),
      password: yup.string().required(),
    })
  );

  const methods = useForm({ resolver });
  const { handleSubmit, register, control, formState: { errors } } = methods;

  const [success, setSuccess] = useState<Boolean>(true);
  const [error, setError] = useState<Boolean>(true);

  const onSubmitForm = (values: any) => {
    alert(values);
  };

  if (userProfile) return <Navigate to="/dashboard" />;

  return (
    <NonAuthLayoutWrapper>
      <Row className="justify-content-center my-auto">
        <Col sm={8} lg={6} xl={5}>
          <div className="py-md-5 py-4">

            <AuthHeader title="Register Account" subtitle="Get your free Doot account now." />

            {success && <Alert fade timeout={150} color="success">Colocar mensagem de sucesso</Alert>}
            {error && <Alert fade timeout={150} color="danger">Colocar mensagem de erro</Alert>}

            <Form onSubmit={handleSubmit(onSubmitForm)} className="position-relative">
              {/* {loading && <Loader />} */}

              <div className="mb-3">
                <FormInput
                  label="Email"
                  name="email"
                  register={register}
                  errors={errors}
                  control={control}
                />
              </div>

              <div className="mb-3">
                <FormInput
                  label="Username"
                  name="username"
                  register={register}
                  errors={errors}
                  control={control}
                />
              </div>

              <div className="mb-3">
                <FormInput
                  label="Password"
                  name="password"
                  type="password"
                  register={register}
                  errors={errors}
                  control={control}
                />
              </div>

              <Button color="primary" className="w-100" type="submit">
                Register
              </Button>
            </Form>

            <div className="text-center mt-4">
              <p>
                Already have an account?{" "}
                <Link to="/auth-login" className="fw-medium text-decoration-underline">
                  Login
                </Link>
              </p>
            </div>

          </div>
        </Col>
      </Row>
    </NonAuthLayoutWrapper>
  );
};

export default Register;
